import { EDataRoomSection } from "../../model/types/types";

export const mockOverviewSectionData = {
  logo: "",
  name: "Open AI",
  website: "https://openai.com",
  shortDescription:
    "OpenAI is an AI research and deployment company that conducts research and implements machine learning.",
  tags: ["Fintech", "Blockchain", "New"],
  linkedin: "https://www.linkedin.com/company/openai/",
  twitter: "https://twitter.com/OpenAI",
  description:
    "OpenAI is an AI research and deployment company dedicated to ensuring that general-purpose artificial intelligence benefits all of humanity. AI is an extremely powerful tool that must be created with safety and human needs at its core. OpenAI is dedicated to putting that alignment of interests first — ahead of profit.",
  location: "United States",
  team: ["Evan Spiegel", "Andrew Miller", "Sara Lee"],
  foundation: "2015",
  evaluation: "100000",
  totalFunding: "1000000",
  FinancialStage: "Pre-seed",
  founders: [
    { name: "Andrew Miller", position: "CEO" },
    { name: "Sara Lee", position: "CFO" }
  ]
};

export const mockInvestorsData = [
  {
    name: "Evan Spiegel"
  },
  {
    name: "Andrew Miller"
  },
  {
    name: "Sara Lee"
  },
  {
    name: "Evan Spiegel"
  },
  {
    name: "Andrew Miller"
  },
  {
    name: "Sara Lee"
  }
];

export const mockFinancingSectionData = {
  fundingRounds: 8,
  totalFunding: "1000000",
  leadInvestments: 3,
  investments: 3
};

export const mockMarketSectionData = {
  targetMarket: ["SMB", "Mid", "Large"],
  TAM: "1000000",
  SAM: "1000000",
  SOM: "1000000"
};

export const mockMetricsSectionData = {
  annualRevenue: "1000000",
  annualCosts: "1000000",
  annualProfit: "1000000",
  monthlyBurnRate: "1000000",
  MRR: "1000000",
  ARR: "1000000",
  ChurnRate: "1000000",
  LTV: "1000000",
  CAC: "1000000"
};

export const mockTeamData = [
  {
    name: "Evan Spiegel",
    position: "CEO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Andrew Miller",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Sara Lee",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Evan Spiegel",
    position: "CEO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Andrew Miller",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Sara Lee",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Evan Spiegel",
    position: "CEO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Andrew Miller",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Sara Lee",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  }
];

export const mockCompetitorsData = [
  {
    name: "Competitor A",
    description:
      "Competitor A is an AI research and deployment company dedicated to ensuring that general-purpose artificial intelligence benefits all of humanity.",
    url: "https://competitorA.com",
    image: ""
  },
  {
    name: "Competitor B",
    description:
      "Competitor B is an AI research and deployment company dedicated to ensuring that general-purpose artificial intelligence benefits all of humanity.",
    url: "https://competitorB.com",
    image: ""
  },
  {
    name: "Competitor C",
    description:
      "Competitor C is an AI research and deployment company dedicated to ensuring that general-purpose artificial intelligence benefits all of humanity.",
    url: "https://competitorC.com",
    image: ""
  },
  {
    name: "Competitor D",
    description:
      "Competitor D is an AI research and deployment company dedicated to ensuring that general-purpose artificial intelligence benefits all of humanity.",
    url: "https://competitorD.com",
    image: ""
  }
];

export const mockTeamSectionData = [
  {
    name: "Evan Spiegel",
    position: "CEO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Andrew Miller",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Sara Lee",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Evan Spiegel",
    position: "CEO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Andrew Miller",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Sara Lee",
    position: "CFO",
    image: "",
    linkedin: "https://www.linkedin.com/company/openai/"
  }
];

export const sidebarOptions = [
  "Overview",
  "Financing",
  "Team",
  "Market",
  "Product & Services",
  "Competitors"
  // "Metrics"
];

export const sidebarRestrictedOptions = [
  "Team",
  "Market",
  "Product & Services",
  "Competitors"
  // "Metrics"
];

export const initialDataRoom = {
  [EDataRoomSection.TEAM_DOCUMENTS]: false,
  [EDataRoomSection.CUSTOMERS_AND_PARTNERS]: false,
  [EDataRoomSection.SALES_AND_MARKETING]: false,
  [EDataRoomSection.FINANCIALS]: false,
  [EDataRoomSection.MARKET_AND_COMPETITION]: false,
  [EDataRoomSection.PRODUCT_AND_TECHNOLOGY]: false,
  [EDataRoomSection.LEGAL]: false,
  [EDataRoomSection.OTHER]: false
};

export const marketFactsAndFiguresMockData = {
  marketSize: "1000000",
  marketSizeDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  cagr: "10",
  cagrDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  enterpriceMarketValue: "100000",
  enterpriceMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  NLPMarketValue: "100000",
  NLPMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  ImageProcessMarketValue: "100000",
  ImageProcessMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  srMarketValue: "100000",
  srMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  cloudbasedContactMarketValue: "100000",
  cloudbasedContactMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026.",
  chatbotMarketValue: "100000",
  chatbotMarketValueDescription: "Expected to register a CAGR of 35.4% between 2019 and 2026."
};

export const marketOverviewSectionDescription = `
  The global AI market is experiencing exponential growth, driven by the increasing adoption of AI technologies across various sectors such as healthcare, finance, automotive, and retail. According to recent reports, the AI market is projected to reach $190 billion by 2025, with a compound annual growth rate (CAGR) of 36.62% from 2020 to 2025.
  `;

export const summaryMockDescription =
  "OpenAI Business Solutions provides a comprehensive suite of advanced artificial intelligence tools and services designed to transform and optimize business operations across various industries. Leveraging cutting-edge AI research and state-of-the-art models, OpenAI empowers enterprises to harness the power of AI for automation, decision-making, and enhanced customer experiences.";

export const mockProductsData = [
  {
    name: "Product A",
    description:
      "Product A is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://productA.com",
    image: ""
  },
  {
    name: "Product B",
    description:
      "Product B is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://productB.com",
    image: ""
  },
  {
    name: "Product C",
    description:
      "Product C is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://productC.com",
    image: ""
  },
  {
    name: "Product D",
    description:
      "Product D is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://productD.com",
    image: ""
  }
];

export const mockPatentsData = [
  {
    name: "Patent A",
    ID: "2318853A2KL"
  },
  {
    name: "Patent B",
    ID: "2318853A2KL"
  },
  {
    name: "Patent C",
    ID: "2318853A2KL"
  },
  {
    name: "Patent D",
    ID: "2318853A2KL"
  },
  {
    name: "Patent E",
    ID: "2318853A2KL"
  },
  {
    name: "Patent F",
    ID: "2318853A2KL"
  },
  {
    name: "Patent G",
    ID: "2318853A2KL"
  },
  {
    name: "Patent H",
    ID: "2318853A2KL"
  }
];

export const marketLandscapeMockData = [
  {
    name: "Market Landscape A",
    description:
      "Market Landscape A is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeA.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape B",
    description:
      "Market Landscape B is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeB.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape C",
    description:
      "Market Landscape C is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeC.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape D",
    description:
      "Market Landscape D is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeD.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape E",
    description:
      "Market Landscape E is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeE.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape F",
    description:
      "Market Landscape F is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeF.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape G",
    description:
      "Market Landscape G is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeG.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  },
  {
    name: "Market Landscape H",
    description:
      "Market Landscape H is an AI research and deployment company that conducts research and implements machine learning.",
    url: "https://marketLandscapeH.com",
    image: "",
    country: "USA",
    city: "San Francisco",
    yearFounded: "2015",
    linkedin: "https://www.linkedin.com/company/openai/"
  }
];

export const notesMockData = [
  {
    name: "Kevin Huang",
    date: "2022-01-01",
    comment:
      "The startup has shared impressive financial metrics reflecting strong performance and growth potential. Their annual revenue is $10.8M, with annual costs of $4.2M, resulting in a significant annual profit of $15M. The monthly burn rate is maintained at $520K."
  },
  {
    name: "Kevin Huang",
    date: "2022-01-01",
    comment: "The startup has shared impressive financial metrics reflecting strong performance and growth potential."
  },
  {
    name: "Kevin Huang",
    date: "2022-01-01",
    comment: "The startup has shared impressive financial metrics reflecting strong performance and growth potential."
  }
];
